import { Formik } from 'formik'
import * as Yup from 'yup'
import { Link, useNavigate } from 'react-router-dom'
import { usePostLoginMutation } from '../../api/api'
import { useEffect } from 'react'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import useQuery from '../../utils/hooks/useQuery'
import PasswordInput from '../../components/PasswordInput/PasswordInput'
import Logo from '../../assets/images/logo.png'

const LoginView = ({ user }) => {
  const queryParams = useQuery()
  const navigate = useNavigate()
  const [postUserLogin, { isLoading, error }] = usePostLoginMutation()
  const schema = Yup.object().shape({
    email: Yup.string().required('Username/email is a required field'),
    password: Yup.string()
      .required('Password is a required field')
      .min(8, 'Password must be at least 8 characters'),
  })

  useEffect(() => {
    if (user?.id) {
      navigate('/library')
    }
  }, [navigate, user?.id])

  function onLogin(values) {
    postUserLogin(values).then((res) => {
      if (!res?.error) {
        navigate('/challenge')
      }
    })
  }

  return (
    <div className="flex w-full h-full items-center justify-center h-full relative overflow-hidden">
      <div className="login-bg"></div>
      <div className="w-[600px]">
        <div className="flex items-center mb-6">
          <img src={Logo} alt="Sharefolio logo" className="w-[48px] z-[100]" />
          <div className="text-salmon font-heading font-bold ml-2 text-4xl pt-2 z-[100]">
            Sharefolio
          </div>
     
        </div>
        <div className="bg-gray-light p-12 rounded drop-shadow-lg mb-10 relative">
          <h2 className=" mb-6">Sign in to your account</h2>
          <Formik
            validationSchema={schema}
            initialValues={{ email: '', password: '' }}
            onSubmit={(values) => {
              onLogin(values)
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <div className="login">
                {!error && queryParams.error && (
                  <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
                    {queryParams.error === 'code_expired' && (
                      <p>Your login code has expired, please log in again.</p>
                    )}
                  </div>
                )}
                {error && (
                  <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
                    <p>The email or password you entered is incorrect.</p>
                  </div>
                )}
                <div className="form">
                  <form noValidate onSubmit={handleSubmit}>
                    <label htmlFor="email">Username / Email</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      placeholder="Email"
                      className="form-control inp_text"
                      id="email"
                    />
                    <p className="error">
                      {errors.email && touched.email && errors.email}
                    </p>
                    <label className="mt-4 inline-block" htmlFor="password">
                      Password
                    </label>
                    <PasswordInput
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      placeholder="Password"
                      className="form-control"
                    />
                    <p className="error">
                      {errors.password && touched.password && errors.password}
                    </p>
                    <div className="mt-3 ml-1">
                      <Link
                        to="/forgotPassword"
                        className="text-white-purple text-sm"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                    <div className="flex justify-end pt-6">
                      <div>
                        <Link
                          className="button bg-transparent hover:bg-gray-dark text-white-dark inline-block"
                          to="/signup"
                        >
                          Sign up
                        </Link>
                      </div>
                      <div className="ml-2">
                        <button
                          className="button bg-purple-light hover:bg-purple-light-med"
                          type="submit"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </Formik>
          {isLoading && <LoadingBlocker />}
        </div>
      </div>
    </div>
  )
}

export default LoginView
